import { createContext, useContext } from "react";
import type { Theme } from "../lib/theme";

export const ThemeContext = createContext<{ theme: Theme; toggle: () => void }>({
  theme: "light",
  toggle: () => undefined,
});

export function useThemeContext() {
  return useContext(ThemeContext);
}
